import { Accordion, AccordionButton, AccordionIcon, VStack } from "@chakra-ui/react"
import React, { ReactNode } from "react"

type AccordionSectionProps = {
  isDefaultOpen: boolean
  children: ReactNode
}

export function AccordionSection({ isDefaultOpen, children }: AccordionSectionProps) {
  return isDefaultOpen ? (
    <>
      <Accordion defaultIndex={[0]} allowMultiple>
        <VStack spacing={"27px"} align={"start"}>
          {children}
        </VStack>
      </Accordion>
    </>
  ) : (
    <>
      <Accordion allowMultiple>
        <VStack spacing={"27px"} align={"start"}>
          {children}
        </VStack>
      </Accordion>
    </>
  )
}

export function AccordionItemHeader(props) {
  return (
    <h2>
      <AccordionButton w={"630px"} paddingLeft={"0px"} paddingRight={"0px"} justifyContent={"space-between"}>
        {props.children}
        <AccordionIcon />
      </AccordionButton>
    </h2>
  )
}
